// Altitude layers as the backend defines them (utils/deconfliction.js): home up
// to the ceiling (400 ft) split into equal bands. One colour per layer, shared by
// the 3D corridor tube and the layer picker so a colour on the map reads as the
// same layer in the list.

// Layer number (1 = lowest) for a height above home, or null above the ceiling.
export function layerOf(agl, { layerCeilingMeters, layerCount }) {
  const count = Math.round(Number(layerCount));
  const h = Number(layerCeilingMeters) / count;
  if (!(count >= 1) || !(h > 0) || !Number.isFinite(agl) || agl >= Number(layerCeilingMeters)) return null;
  return Math.max(1, Math.floor(agl / h) + 1);
}

// Evenly spaced hues from sky blue (layer 1) to violet (top layer). Kept clear
// of green, amber and pink, which the 3D corridor uses for takeoff, landing and
// delivery drops — a layer colour never reads as a flight phase.
export function layerColor(layer, layerCount) {
  const count = Math.max(1, Math.round(Number(layerCount)));
  const hue = 195 + (100 * (layer - 1)) / Math.max(1, count - 1);
  return `hsl(${Math.round(hue)}, 75%, 55%)`;
}
